import { GALLERY } from "../lib/brand";

export default function Gallery() {
  return (
    <section
      id="galeria"
      data-testid="gallery-section"
      className="py-20 sm:py-28 border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-10 sm:mb-14">
          <div>
            <div className="label-eyebrow mb-3">[ Pátio / Operação ]</div>
            <h2 className="font-display font-bold text-white text-3xl sm:text-5xl tracking-tight">
              Fotos reais do<br />
              <span className="text-[var(--rc-copper-bright)]">nosso dia a dia.</span>
            </h2>
          </div>
          <p className="text-zinc-400 max-w-md text-sm sm:text-base">
            Pátio organizado, balança aferida, caminhão para retirada e equipe pronta para atender em Maringá e região.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {GALLERY.map((g, i) => (
            <div
              key={i}
              data-testid={`gallery-item-${i}`}
              className={`bg-black overflow-hidden ${
                i === 0 ? "md:col-span-2 md:row-span-2" : ""
              }`}
            >
              <img
                src={g.src}
                alt={g.alt}
                loading="lazy"
                className={`w-full h-full object-cover hover:scale-105 transition-transform duration-700 ${
                  i === 0 ? "aspect-square md:aspect-auto md:h-full" : "aspect-square"
                }`}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
